import React, { useEffect } from "react";
import moment from "moment/moment";
import { useLanguageForShared } from "../../../../shared/utils/languages/useLanguageForShared";
import LabelValueCopy from "../../../../shared/custom/labelValue/LabelValueCopy";
import { useSelector } from "react-redux";
import { selectCustomers, selectSelectedCustomer } from "../../../../redux/customer/customerSlice";
import {
    getDistrictNameByGuid,
    hasCustomerDistricts
} from "../../../../app/utils/districtUtils";

const resolveDistrictName = (selectedCustomer, customers, districtGuid) => {
    const districtFromSelected = getDistrictNameByGuid(selectedCustomer, districtGuid);
    if (districtFromSelected) {
        return districtFromSelected;
    }

    if (!districtGuid) {
        return "";
    }

    const customerWithDistrict = (customers || []).find((customer) =>
        hasCustomerDistricts(customer) &&
        (customer?.districts || []).some((district) => district?.id === districtGuid)
    );

    return getDistrictNameByGuid(customerWithDistrict, districtGuid);
};

const DetailPatientRegistry = ({ patient }: { patient: any }) => {
    const { t } = useLanguageForShared();
    const selectedCustomer = useSelector(selectSelectedCustomer);
    const customers = useSelector(selectCustomers);

    const birthdate = patient?.birthDate ? moment(patient?.birthDate).format("DD MMM YY") : patient?.DateOfBirth ? moment(patient?.DateOfBirth).format("DD MMM YY") : "-";
    const districtName = resolveDistrictName(selectedCustomer, customers, patient?.residence?.districtGuid);
    
    const residence = `${patient?.residence?.street ? patient?.residence?.street : "-"}${patient?.residence?.number ? (", " + patient?.residence?.number) : ""} ${patient?.residence?.city || ""} ${patient?.residence?.province || ""} ${patient?.residence?.cap || ""}${districtName ? ` (${districtName})` : ""}`;
    const domicile = `${patient?.domicile?.street ? patient?.domicile.street : "-"}${patient?.domicile?.number ? (", " + patient?.domicile?.number) : ""} ${patient?.domicile?.city || ""} ${patient?.domicile?.province || ""} ${patient?.domicile?.cap || ""}`;

    return (
        <div className={"detail-patient"}>
            <div className={"d-flex flex-wrap gap-5 info-col"}>
                <LabelValueCopy label={t("registry.name")} value={patient?.name || "-"} />
                <LabelValueCopy label={t("registry.surname")} value={patient?.surname || "-"} />
                <LabelValueCopy label={t("registry.birthdate")} value={birthdate || "-"} />
                <LabelValueCopy label={t("registry.fiscalCode")} value={patient?.cf || "-"} />
                <LabelValueCopy label={t("registry.gender")} value={patient?.gender ? t("common." + patient?.gender?.toLowerCase()) : "-"} />
                <LabelValueCopy label={t("registry.telephone")} value={patient?.phone || "-"} />
                <LabelValueCopy label={t("registry.mobile")} value={patient?.mobile || "-"} />
                <LabelValueCopy label={t("registry.email")} value={patient?.email || "-"} />
            </div>
            <div className={"d-flex flex-wrap gap-5"}>
            </div>
            <div className={"d-flex flex-wrap gap-5 address-col"}>
                <LabelValueCopy label={t("registry.resident")} value={residence} />
                <LabelValueCopy label={t("registry.domicileIn")} value={domicile} />
            </div>
        </div>
    );
};

export default DetailPatientRegistry;
